module.exports = __webpack_public_path__ + "static/demoaccesscompany-logo-1cc7dfbaa909cb3af5e6e9112c065cf1.png";